import React from 'react';
import { Box, Paper, Typography, CircularProgress } from '@material-ui/core';
import VirtualList from 'react-tiny-virtual-list';
import { SessionListItem } from './SessionListItem';

export function SessionsPanel({
	classes,
	sessions,
	selectedSessionId,
	onSelectSession,
	sessionsLoading,
	sessionsLoadingMore,
	hasMoreSessions,
	listHeight,
	listRef,
	onLoadMore,
}) {
	return (
		<Paper className={classes.sessionsPanel} elevation={0}>
			<Box className={classes.sessionsHeader}>
				<Typography variant="subtitle1" className={classes.sectionTitle}>Sessions</Typography>
			</Box>
			<Box ref={listRef} className={classes.sessionsList}>
				{sessionsLoading ? (
					<Box display="flex" justifyContent="center" alignItems="center" minHeight={120}><CircularProgress /></Box>
				) : sessions.length === 0 ? (
					<Box p={2}><Typography variant="body2" color="textSecondary">No sessions in this period.</Typography></Box>
				) : (
					<VirtualList
						width="100%"
						height={listHeight}
						itemCount={sessions.length + (hasMoreSessions ? 1 : 0)}
						itemSize={140}
						onScroll={(scrollOffset, e) => {
							const { scrollTop, scrollHeight, clientHeight } = e.target;
							if (scrollTop + clientHeight >= scrollHeight - 80) onLoadMore();
						}}
						renderItem={({ index, style }) => {
							if (index >= sessions.length) {
								return (
									<div key="loader" style={style}>
										<Box display="flex" justifyContent="center" alignItems="center" py={2}>
											{sessionsLoadingMore ? <CircularProgress size={24} /> : null}
										</Box>
									</div>
								);
							}
							const session = sessions[index];
							return (
								<div key={session.id} style={style}>
									<SessionListItem
										session={session}
										selected={selectedSessionId === session.id}
										onClick={() => onSelectSession(session.id)}
										classes={classes}
									/>
								</div>
							);
						}}
					/>
				)}
			</Box>
		</Paper>
	);
}
